export enum WorkspaceSettingsSettingTabsTypeEnum {
    General = 'GENERAL',
    Members = 'MEMBERS',
}
